const modelPrettifier = {
  douro1: 'Douro',
  sintra: 'Sintra',
  gaia: 'Gaia',
  tejo: 'Tejo'
}

export { modelPrettifier }
